import { render } from "./AllJobs.vue?vue&type=template&id=10d4b988&ts=true"
import script from "./AllJobs.vue?vue&type=script&lang=ts"
export * from "./AllJobs.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__